import { flushSync } from 'react-dom';

export const isSupportViewTransition = 'startViewTransition' in document;

/**
 * @description startViewTransition包装函数，可用于过渡视图，不支持时默认回退，
 * 但是注意他会破坏react的batch update，请谨慎使用
 */
export const createViewTransition = (
  updateCallback: () => void | Promise<void>,
) =>
  isSupportViewTransition
    ? document.startViewTransition(() => flushSync(updateCallback))
    : (() => {
        updateCallback();
      })();
